import { Inject, Injectable, Optional } from '@angular/core';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { JwtTokens } from '@wizbii/jwt';
import atob from 'atob';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  static readonly TOKEN_KEY = `wizbii_tokens`;
  static readonly EXPIRY_KEY = `wizbii_tokens_expiry`;

  private _tokens: JwtTokens;
  private _userId: string;
  private _roles: string[];

  get tokens(): JwtTokens {
    return this._tokens;
  }

  get userId(): string {
    return this._userId;
  }

  get roles(): string[] {
    return this._roles;
  }

  /* eslint-disable */
  constructor(@Optional() @Inject(REQUEST) request: any, private readonly cookieService: CookieService) {
    if (request) {
      this.init(request.jwt || null, request.refreshToken || null);
    } else {
      const rawTokens = JSON.parse(this.cookieService.get(GlobalService.TOKEN_KEY) || 'null');

      this.init(
        rawTokens && rawTokens['token'] ? rawTokens['token'] : null,
        rawTokens && rawTokens['refreshToken'] ? rawTokens['refreshToken'] : null
      );
    }
  }

  private parseJwt(jwt: string) {
    return JSON.parse(atob(jwt.split('.')[1]));
  }

  init(token?: string, refreshToken?: string): void {
    this._tokens = token && refreshToken ? { token, refreshToken } : null;
    this._userId = this._tokens ? this.parseJwt(this._tokens.token)['user-id'] : null;
    this._roles = this._tokens ? this.parseJwt(this._tokens.token)['roles'] : null;
  }
}
